/* SecureNu thema: algemene scripts. Geen afhankelijkheden. */
(function () {
  'use strict';

  var theme = window.theme = window.theme || {};
  theme.strings = theme.strings || {};
  theme.routes = theme.routes || { cart: '/cart', cartAdd: '/cart/add' };

  /* ---------- Geld ---------- */
  theme.formatMoney = function (cents, format) {
    var template = format || theme.moneyFormat || '€{{amount_with_comma_separator}}';
    function withDelimiters(number, precision, thousands, decimal) {
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    return template.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount': return withDelimiters(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        case 'amount_with_space_separator': return withDelimiters(cents, 2, ' ', ',');
        default: return withDelimiters(cents, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  };

  /* ---------- Melding ---------- */
  var toastTimer;
  theme.toast = function (message, link) {
    var toast = document.querySelector('[data-toast]');
    if (!toast) return;
    toast.textContent = '';
    toast.appendChild(document.createTextNode(message + ' '));
    if (link) {
      var a = document.createElement('a');
      a.href = link.href;
      a.textContent = link.label;
      toast.appendChild(a);
    }
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 6000);
  };

  /* ---------- Winkelwagen in de header bijwerken ---------- */
  theme.refreshCart = function () {
    return fetch(theme.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (node) {
          node.textContent = cart.item_count;
          node.hidden = cart.item_count === 0;
        });
        document.querySelectorAll('[data-cart-total]').forEach(function (node) {
          node.textContent = theme.formatMoney(cart.total_price);
        });
        return cart;
      });
  };

  /* ---------- Toevoegen aan winkelwagen ---------- */
  function initProductForms(scope) {
    scope.querySelectorAll('form[data-product-form]').forEach(function (form) {
      if (form.dataset.bound || !theme.cartAjax) return;
      form.dataset.bound = 'true';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = document.querySelector('[data-add-button][form="' + form.id + '"]') || form.querySelector('[type="submit"]');
        var errorBox = document.querySelector('[data-product-error]');
        if (errorBox) errorBox.hidden = true;
        if (button) button.disabled = true;
        fetch(theme.routes.cartAdd + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (response) {
            return response.json().then(function (data) {
              if (!response.ok) throw new Error(data.description || data.message || theme.strings.error);
              return data;
            });
          })
          .then(function () {
            theme.toast(theme.strings.added, { href: theme.routes.cart, label: theme.strings.viewCart });
            return theme.refreshCart();
          })
          .catch(function (error) {
            if (errorBox) {
              errorBox.textContent = error.message;
              errorBox.hidden = false;
            }
          })
          .then(function () {
            if (button) button.disabled = false;
          });
      });
    });
  }

  /* ---------- Productpagina: varianten en galerij ---------- */
  function initProduct(scope) {
    scope.querySelectorAll('[data-product]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = 'true';

      function showMedia(id) {
        var target = root.querySelector('[data-media-id="' + id + '"]');
        if (!target) return;
        root.querySelectorAll('.product__media').forEach(function (m) { m.classList.toggle('is-active', m === target); });
        root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
          thumb.classList.toggle('is-active', thumb.dataset.thumb === String(id));
        });
      }
      root.querySelectorAll('[data-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () { showMedia(thumb.dataset.thumb); });
      });

      var jsonEl = root.querySelector('[data-product-json]');
      var options = root.querySelector('[data-options]');
      if (!jsonEl || !options) return;
      var variants;
      try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return; }

      options.addEventListener('change', function () {
        var selected = [];
        options.querySelectorAll('input:checked').forEach(function (input) {
          selected[Number(input.dataset.optionIndex)] = input.value;
        });
        var variant = variants.filter(function (v) {
          return v.options.every(function (value, index) { return value === selected[index]; });
        })[0];

        var button = root.querySelector('[data-add-button]');
        var priceBox = root.querySelector('[data-price]');
        var stock = root.querySelector('[data-stock]');
        var dynamic = root.querySelector('[data-dynamic-checkout]');

        if (!variant) {
          if (button) { button.disabled = true; button.textContent = theme.strings.unavailable; }
          if (dynamic) dynamic.hidden = true;
          return;
        }
        root.querySelectorAll('[data-variant-id]').forEach(function (input) { input.value = variant.id; });
        if (button) {
          button.disabled = !variant.available;
          button.textContent = variant.available ? theme.strings.addToCart : theme.strings.soldOut;
        }
        if (dynamic) dynamic.hidden = !variant.available;
        if (priceBox) {
          var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          priceBox.textContent = '';
          var wrap = document.createElement('span');
          wrap.className = 'price' + (onSale ? ' price--sale' : '');
          var now = document.createElement('span');
          now.className = 'price__now';
          now.textContent = theme.formatMoney(variant.price);
          wrap.appendChild(now);
          if (onSale) {
            var was = document.createElement('s');
            was.className = 'price__was';
            was.textContent = theme.formatMoney(variant.compare_at_price);
            wrap.appendChild(document.createTextNode(' '));
            wrap.appendChild(was);
          }
          priceBox.appendChild(wrap);
        }
        if (stock) {
          stock.classList.toggle('is-out', !variant.available);
          if (stock.firstChild) stock.firstChild.textContent = variant.available ? stock.dataset.in : stock.dataset.out;
        }
        if (variant.featured_media) showMedia(variant.featured_media.id);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* ---------- Productraster met filterknoppen ---------- */
  function initFilterGrids(scope) {
    scope.querySelectorAll('[data-filter-grid]').forEach(function (grid) {
      if (grid.dataset.bound) return;
      grid.dataset.bound = 'true';
      var chips = grid.querySelectorAll('[data-filter]');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var value = chip.dataset.filter;
          chips.forEach(function (other) {
            var active = other === chip;
            other.classList.toggle('is-active', active);
            other.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          grid.querySelectorAll('[data-filter-item]').forEach(function (item) {
            item.hidden = !(value === '*' || item.dataset.filterItem === value);
          });
        });
      });
    });
  }

  /* ---------- Aanbevolen producten ---------- */
  function initRecommendations(scope) {
    scope.querySelectorAll('[data-recommendations]').forEach(function (section) {
      if (section.dataset.bound || section.querySelector('.product-grid')) return;
      section.dataset.bound = 'true';
      fetch(section.dataset.url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.querySelector('.product-grid')) {
            section.innerHTML = fresh.innerHTML;
          } else {
            section.hidden = true;
          }
        })
        .catch(function () { section.hidden = true; });
    });
  }

  /* ---------- Kleine hulpjes ---------- */
  function initMisc(scope) {
    // Formulier versturen zodra een veld verandert (sorteren, aantal in winkelwagen).
    scope.querySelectorAll('[data-auto-submit]').forEach(function (field) {
      if (field.dataset.bound) return;
      field.dataset.bound = 'true';
      field.addEventListener('change', function () {
        if (field.form) field.form.submit();
      });
    });
    // Bevestiging vragen (adres verwijderen).
    scope.querySelectorAll('form[data-confirm]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      form.addEventListener('submit', function (event) {
        if (!window.confirm(form.dataset.confirm)) event.preventDefault();
      });
    });
    // Land voorselecteren in adresformulieren.
    scope.querySelectorAll('select[data-default]').forEach(function (select) {
      var wanted = select.dataset.default;
      if (!wanted) return;
      Array.prototype.forEach.call(select.options, function (option) {
        if (option.value === wanted || option.textContent === wanted) select.value = option.value;
      });
    });
    // Filters op mobiel standaard dichtgeklapt.
    scope.querySelectorAll('details.filters').forEach(function (details) {
      if (window.matchMedia('(max-width: 989px)').matches) details.removeAttribute('open');
    });
  }

  function initAll(scope) {
    var root = scope || document;
    initProductForms(root);
    initProduct(root);
    initFilterGrids(root);
    initRecommendations(root);
    initMisc(root);
  }

  // Mobiel menu sluiten met Escape.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-mobile-nav][open]').forEach(function (nav) { nav.removeAttribute('open'); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
